import React from 'react'
import { Box } from '@mui/material'
import useClasses from '@/components/hooks/UseClasses'
import HeaderMobile from '../header/HeaderMobile'
import { Outlet } from 'react-router-dom'

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100dvh',
  },
  outlet: {
    height: '100%',
    padding: '1rem',
    overflowY: 'auto',
  },
})

const MobileLayout = ({ standard = true }) => {
  const classes = useClasses(styles)
  return (
    <>
      <Box className={classes.container}>
        <HeaderMobile standard={standard} />
        <Box className={classes.outlet}>
          <Outlet />
        </Box>
      </Box>
    </>
  )
}

export default MobileLayout
